import { useState, useEffect } from 'react';
import firebase from 'firebase/app';

export function useAdminTapsByUserId(userId, startDate, endDate, limit = 100) {
  const [loading, setLoading] = useState(true);
  const [taps, setTaps] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!userId) {
      setTaps([]);
      setLoading(false);
      return () => {};
    }
    setLoading(true);
    setError(null);
    const db = firebase.firestore();
    let query = db.collectionGroup('taps').where('striker_userId', '==', userId);
    if (startDate) query = query.where('createdAt', '>=', firebase.firestore.Timestamp.fromDate(startDate));
    if (endDate) query = query.where('createdAt', '<=', firebase.firestore.Timestamp.fromDate(endDate));
    query = query.orderBy('createdAt', 'desc').limit(limit);
    const unsubscribe = query.onSnapshot(
      (snap) => {
        setTaps(snap.docs.map((doc) => ({
          id: doc.id,
          tagId: doc.ref.parent.parent.id,
          ...doc.data(),
        })));
        setLoading(false);
      },
      (err) => {
        console.error('[useAdminTapsByUserId] Failed:', err);
        setError(err.message || 'Failed to load taps');
        setTaps([]);
        setLoading(false);
      }
    );
    return () => unsubscribe();
  }, [userId, startDate, endDate, limit]);

  return [loading, taps, error];
}
